
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.566 129.081c0 .24-.014.464-.029.717.355.283.667.616 1.087.848 11.483 6.258 23.632 8.344 36.563 6.244 25.761-4.15 43.075-27.634 44.119-52.58.087-1.55.934-3.274 1.89-4.55 1.565-2.042 3.58-3.758 5.303-5.67.594-.66 1.03-1.464 1.5-2.203-.08-.123-.203-.224-.311-.34-2.478.695-4.985 1.427-7.448 2.137-.087-.152-.152-.283-.239-.435 2.021-2.926 4.057-5.867 6.093-8.772a20.661 20.661 0 00-.58-.557c-1.659.724-3.332 1.361-4.955 2.144-3.789 1.789-6.998 1.818-10.787-.855-9.65-6.874-24.566-1.507-27.877 11.017-.76 2.898-.652 6.034-.992 9.228-15.38-1.028-27.819-8.38-38.28-20.028-4.108 9.605-2.746 17.862 4.673 25.113a4.418 4.418 0 00-.616.362c-2.18-.63-4.368-1.253-6.846-1.963.674 9.236 5.397 15.197 13.641 18.782-.463.21-.587.305-.688.305-1.116.058-2.195.101-3.296.145-2.695.08-2.927.398-1.68 2.824 2.52 4.911 6.787 7.678 11.757 9.605 1.173.464 2.369.855 3.666 1.318-7.701 5.745-16.46 7.208-25.668 7.164M6 99.811C6.529 47.499 48.482 5.799 100.135 6c52.812.21 95.525 43.736 93.815 97.192-1.615 50.487-43.894 92.527-97.285 90.753C46.692 192.273 5.957 151.196 6 99.81","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    